import { AccountNavigationItem } from "./providerAccountsNavigationSelector";
import { RootState } from "../../../store";
import { getProviderName } from "../../../../utils/helpers/providers/getProviderName";
import { kubernetesClustersSelector } from "../kubernetes/kubernetesClustersSelector";
import { noOrgAccountOrgId } from "../../../../components/pages/accounts-group/utils/helpers/noOrganizationConstants";

export const kubernetesClustersNavigationSelector = (
  state: RootState,
): AccountNavigationItem[] | undefined => {
  const clusters = kubernetesClustersSelector(state);

  return [
    {
      provider: "kubernetes",
      org: getProviderName("kubernetes", {
        nameAndTitle: true,
        capitalize: true,
        plural: true,
      }),
      orgId: noOrgAccountOrgId,
      accountIds: clusters?.map((item) => item.id) ?? [],
    },
  ];
};
